(function () {
  const isMobile = () => window.matchMedia("(max-width: 749px)").matches;

  // Find the media element or gallery section to scroll to
  function findTarget(root, mediaId) {
    return (
      (mediaId && root.querySelector(`[data-media-id='${mediaId}']`)) ||
      root.querySelector("media-gallery") ||
      root.querySelector(".product__media-list") ||
      root.querySelector(".Product__Gallery") ||
      root.querySelector("[data-media-gallery]") ||
      root.querySelector(".product-gallery")
    );
  }

  // Scroll to variant media using scrollIntoView — zero forced reflows.
  // A generous scroll-margin-top accounts for sticky header + announcement bar
  // without reading any offsetHeight/getBoundingClientRect, avoiding synchronous layout.
  function doScroll(formEl, variant) {
    if (!isMobile()) return;

    const section = formEl?.closest("[id^='shopify-section-']") || document;
    const mediaId = variant?.featured_media?.id;
    const target = findTarget(section, mediaId);
    if (!target) return;

    // Set scroll-margin via CSS custom property (header height is typically ~60-80px)
    // Using 120px as a safe generous offset to clear sticky header + announcement bar
    target.style.scrollMarginTop = '120px';
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
  }

  // Core handler for variant events
  function handle(detail, fallbackEl) {
    const form =
      detail?.productForm ||
      detail?.form ||
      fallbackEl?.closest("form") ||
      document.querySelector("form[action*='/cart/add']");

    const variant =
      detail?.variant ||
      form?.currentVariant ||
      (form?.dataset?.currentVariant &&
        JSON.parse(form.dataset.currentVariant)) ||
      null;

    // Delay slightly so image updates first
    setTimeout(() => doScroll(form, variant), 50);
  }

  // Listen for theme events
  document.addEventListener("variant:change", (e) => handle(e.detail));
  document.addEventListener("variant:changed", (e) => handle(e.detail));

  // Fallback: direct listeners on option controls
  function wireFallback() {
    document
      .querySelectorAll("product-form, form[action*='/cart/add']")
      .forEach((form) => {
        form
          .querySelectorAll(
            "variant-radios, variant-selects, select[name^='options'], input[name^='options']"
          )
          .forEach((c) => c.addEventListener("change", () => handle(null, c)));
      });
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", wireFallback);
  } else {
    wireFallback();
  }
})();
